import React, { PropsWithChildren } from 'react';

import useTheme from '../../hooks/use-theme/useTheme';

import { getClassNames } from '../../utils/util';

import PASTLogo from '../../resources/images/logo-blue.png';
import PPSLogo from '../../resources/images/pps/logo-white.png';

import './auth-layout.scss';

type Props = {
  smallLogo?: boolean;
};

const AuthLayout = ({ children, smallLogo }: PropsWithChildren<Props>) => {
  const { pps } = useTheme();

  return (
    <div className={getClassNames('auth-layout', { pps })}>
      <div className="auth-layout__content">
        <div className={getClassNames('auth-layout__card', { pps })}>
          <div className="auth-layout__logo-container">
            <img
              className={getClassNames('auth-layout__logo', { small: smallLogo })}
              src={pps ? PPSLogo : PASTLogo}
              alt="PASTime App Logo"
            />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
